export default __webpack_public_path__ + "static/media/iconLuckyIntelligence.efc67b33.png";